<div class="container">
  <div class="page-title">
    <h1>Cookies Policy</h1>
    <p class="last-updated">Last Updated: June 30, 2024</p>
  </div>

  <h2><strong>Welcome to Akl Bayti!</strong></h2>
  <p>Welcome to Akl Bayti (“we”, “our”, “us”). This Cookies Policy explains how we use cookies and similar technologies on our website. While our website currently does not use cookies, we do utilize local storage to enhance your experience.</p>

  <h2>What Are Cookies?</h2>
  <p>Cookies are small text files that are placed on your device by websites that you visit. They are widely used to make websites work more efficiently, as well as to provide information to the owners of the site. However, Akl Bayti does not currently use cookies.</p>

  <h2>Local Storage</h2>
  <p>Instead of cookies, Akl Bayti uses local storage, a feature of your web browser, to store certain information about your visit. Local storage allows us to store data in your browser without using cookies.</p>

  <h2>What We Store in Local Storage</h2>
  <ul>
    <li><strong>User Account Information:</strong> When you log in to our website, your account information is stored in local storage.</li>
    <li><strong>JWT Token:</strong> A JSON Web Token (JWT) is used to manage your authentication session securely.</li>
  </ul>

  <h2>Why We Use Local Storage</h2>
  <p>We use local storage to:</p>
  <ul>
    <li>Keep you logged in during your session.</li>
    <li>Enhance your user experience by remembering your preferences and settings.</li>
  </ul>

  <h2>Managing Local Storage</h2>
  <p>You have the ability to manage local storage through your web browser settings. Here are some general steps on how to manage local storage:</p>
  <ul>
    <li><strong>Access Browser Settings:</strong> Open your browser settings.</li>
    <li><strong>Privacy and Security:</strong> Look for privacy and security settings.</li>
    <li><strong>Site Settings:</strong> Navigate to site settings or content settings.</li>
    <li><strong>Local Storage:</strong> Find and manage local storage data.</li>
  </ul>
  <p>Please note that deleting or blocking local storage may impact your experience on our website, including the need to log in again for each session.</p>

  <h2>Updates to This Policy</h2>
  <p>We may update this Cookies Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any significant changes by updating the date at the top of this policy.</p>

  <h2>Contact Us</h2>
  <p>If you have any questions or concerns about our use of local storage or this Cookies Policy, please contact us at hello@aklbayti.com.</p>
</div>
